import { useContext } from "react";
import { getApiClientsContext } from "waapi/front-utils/hooks/useApiClients/context.js";
import type { ApiClient, ApiStaffClient } from "./types.js";

export const ApiClientsContext = getApiClientsContext<ApiClient, ApiStaffClient>();

export const useApiClients = () => useContext(ApiClientsContext);
